import classNames from "classnames"
import ArrowIcon from "/static/images/landing/icons/arrow.svg"

import "./link.scss"

const Link = ({ children, tag = "a", href = "#", className, ...props }) => {
  const Tag = tag

  return (
    <Tag
      className={classNames("landing__link", { [className]: className })}
      href={href}
      {...props}
    >
      {children}
      <ArrowIcon />{" "}
    </Tag>
  )
}

export default Link
